import { showToast } from "@/components/feedback";
import { CartError } from "./types";

type ToastId = ReturnType<typeof showToast.loading>;

export class CartNotifications {
  private activeToastId: ToastId | null = null;
  private syncingTimeoutId: ReturnType<typeof setTimeout> | null = null;
  private retryCount = 0;

  showSyncing(): void {
    this.syncingTimeoutId = setTimeout(() => {
      if (!this.activeToastId) {
        this.activeToastId = showToast.loading("Salvando sua sacola...");
      }
    }, 2000);
  }

  hideSyncing(): void {
    if (this.syncingTimeoutId) {
      clearTimeout(this.syncingTimeoutId);
      this.syncingTimeoutId = null;
    }

    if (this.activeToastId) {
      showToast.dismiss(this.activeToastId);
      this.activeToastId = null;
    }

    this.retryCount = 0;
  }

  showRetrying(): void {
    this.retryCount++;

    if (this.retryCount >= 2) {
      showToast.info(`Tentando de novo... (${this.retryCount} de 3)`, {
        autoClose: 2000,
      });
    }
  }

  showError(error: CartError): void {
    this.hideSyncing();

    if (!error.userMessage) return;

    if (error.recoverable) {
      showToast.warning(error.userMessage, {
        autoClose: 5000,
      });
    } else {
      showToast.error(error.userMessage, {
        autoClose: false,
      });
    }
  }

  showSuccess(message: string): void {
    this.hideSyncing();

    showToast.success(message, {
      autoClose: 2000,
    });
  }

  showItemAdded(count: number): void {
    showToast.dismiss();
    showToast.success(
      count === 1
        ? "1 item adicionado à sacola"
        : `${count} itens adicionados à sacola`,
      {
        autoClose: 2000,
      }
    );
  }

  showItemRemoved(count: number): void {
    showToast.dismiss();
    showToast.success(
      count === 1
        ? "1 item removido da sacola"
        : `${count} itens removidos da sacola`,
      {
        autoClose: 2000,
      }
    );
  }

  showOfflineWarning(): void {
    showToast.warning(
      "Você está offline. Assim que a internet voltar, a gente salva tudo.",
      {
        autoClose: false,
        toastId: "offline-warning",
      }
    );
  }

  hideOfflineWarning(): void {
    showToast.dismiss("offline-warning");
  }
}

let notificationsInstance: CartNotifications | null = null;

export function getNotifications(): CartNotifications {
  if (!notificationsInstance) {
    notificationsInstance = new CartNotifications();
  }
  return notificationsInstance;
}

export function resetNotifications(): void {
  notificationsInstance = null;
}
